export default __webpack_public_path__ + "static/media/Asset-Icon-compressor.f41e8e4a.svg";